function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#303C4F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9968 18.1746C9.68376 18.1746 5.99976 18.8546 5.99976 21.5746C5.99976 24.2956 9.66076 24.9996 13.9968 24.9996C18.3098 24.9996 21.9938 24.3206 21.9938 21.5996C21.9938 18.8786 18.3338 18.1746 13.9968 18.1746Z",
  fill: "#F0F0F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9968 15.5837C16.9348 15.5837 19.2888 13.2287 19.2888 10.2917C19.2888 7.35469 16.9348 4.99969 13.9968 4.99969C11.0598 4.99969 8.70483 7.35469 8.70483 10.2917C8.70483 13.2287 11.0598 15.5837 13.9968 15.5837Z",
  fill: "#878794"
});

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.c082208a.svg";
export { ForwardRef as ReactComponent };